import React, { useEffect, useState } from "react";
import axios from "axios";

function Select({ guide }) {

    function onPublicationSelected(event) {
        const publication_id = event.target.value;
        window.location.href = `/feedback/${publication_id}`;
    }

    const options = guide.publications.map((pub) => {
        return <option value={pub.id} key={pub.id}>{pub.name}</option>
    });

    return (
        <select key={guide.id} id={guide.id} onChange={onPublicationSelected}>
            <option value="" key="none"></option>
            {options}
        </select>
    );
}

function Guides({ guides }) {
    const guideList = guides.map((guide) => {
        return (
            <div>
                <h3>{guide.name}</h3>
                <Select guide={guide} />
            </div>
        );
    });

    return (
        guideList
    );
}

export default function Feedback() {
    const [guides, setGuides] = useState([]);

    useEffect(() => {
        axios.get("/feedback.json").then((res) => {
            setGuides(res.data.guides);
        });
    }, []);

    return (
        <div className="container">
            <div className="body">
                <h2>Client Feedback</h2>
                <Guides guides={guides} />
            </div>
        </div>
    );
}
